import { Component, AfterViewInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginComponent} from '../login/login.component';
import {ModuleService} from '../../services/modules.service';
import { NgForm } from '@angular/forms';
// Services
import {OAuthService} from '../../services/oauth.service';

declare let $:any;



@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss' , './mfa.component.medium.scss','../../styles/csc-theme.scss'],
  providers: [LoginComponent]
})
export class MfaComponent implements AfterViewInit {

    private resendAttempts = 1;
    logo = "menu_logo.png";

    verifyCode(form: NgForm) {
      let code = this.concatenate(form.value);
      this.oauthService.verifyMFA(code,(status) => {
        if (status) {
          this.showSuccess();
          this.moduleService.setMfaAlreadyChecked(true);
          this.loginComponent.login();
        }
        else {
          this.showError();
        }
      });
    }


    resendCode() {
      if (this.resendAttempts != 0) {
        this.oauthService.mfa(this.moduleService.getPhone(),(status) => {
          if (status) {
            console.log("Message successfully resent to phone");
            this.resendAttempts--;
          }
        });
      }

    }

  constructor(public router: Router,
    private route: ActivatedRoute,
    private oauthService: OAuthService,
    private loginComponent: LoginComponent,
    private moduleService: ModuleService
  ) {

  }




    ngAfterViewInit() {
      if (!this.moduleService.getUsername()){
          this.router.navigate(['/login']);
      }
        $(document).ready(() => {
          let code = [];
          //set focus on the first input
          $('#firstInput').focus();
          $("#buttonContinue").prop('disabled', true);

          $(".inputs").keyup(function (e) {
            if (this.value.length == this.maxLength) {
              $(this).next('.inputs').focus();
            }
            code[$(this).prop('tabindex') - 1] = $(this).prop('value');
            if(isCodeLengthValid(code)) {
              $("#buttonContinue").prop('disabled', false);
              $('#first').prop('value', code.join(''));
            }
            else {
              $("#buttonContinue").prop('disabled', true);
            }
            if(e.keyCode==8 && $('#firstInput').val().length==1){
              $(this).prev('.inputs').focus();
            }
          });

          $(".inputs").keypress(function () {
            if (this.value.length == this.maxLength) {
              $(this).next('.inputs').focus();
            }
            code[$(this).prop('tabindex') - 1] = $(this).prop('value');
            if(isCodeLengthValid(code)) {
              $("#buttonContinue").prop('disabled', false);
              $('#first').prop('value', code.join(''));
            }
            else {
              $("#buttonContinue").prop('disabled', true);
            }
          });
        });

        function isCodeLengthValid (code) {

          if (code.length < 6)
            return false;
          else {

          for (let i = 0 ; i < 6 ; i++) {
            if (code[i] == '')
            return false;
          }
          return true;
          }
        }


    }


    concatenate(form) {
      let result:string = '';

      Object.values(form).forEach((value) => {
        result += value;
      });

      return result;
    }


    showError() {
      $(".inputs").css("background-color", "#F54B4B");
      $(".inputs").css("transition", "background-color 0.2s ease-in-out");
      setTimeout(() => {
            $(".inputs").css("background-color", "white");
            $(".inputs").css("transition", "background-color 0.8s ease-in-out");
      }, 500);

    }

    showSuccess() {
      $(".inputs").css("background-color", "#7EE876");
      $(".inputs").css("transition", "background-color 0.2s ease-in-out");
      setTimeout(() => {
             $(".inputs").css("background-color", "white");
             $(".inputs").css("transition", "background-color 0.8s ease-in-out");
      }, 500);

      }

}



